import { ENDPOINT } from '~/constants';

import { resolveMutationErrorMessage } from '~/data/utils';

import { vestigasApi } from '~/services/kyClient';
import ToastService from '~/services/toast.service';

import { i18n, log } from '~/utils';

import {
  type ParsingCaseNoteResponse,
  type SaveParsingCaseNoteVariables,
} from '../types';
import { zodParsingCaseNoteResponseSchema } from '../validations';

const ERROR_MESSAGE_BY_STATUS: Record<number, () => string> = {
  404: () =>
    i18n.t(($) => $.saveParsingCaseNote.error404, {
      ns: 'data',
    }),
  422: () =>
    i18n.t(($) => $.saveParsingCaseNote.error422, {
      ns: 'data',
    }),
};

/**
 * Save the note of a parsing case without a retry. Status and jobs stay as
 * they are; an empty note clears it.
 *
 * @param variables - The case UUID and the note
 */
export const saveParsingCaseNote = async ({
  caseId,
  note,
}: SaveParsingCaseNoteVariables): Promise<ParsingCaseNoteResponse> => {
  try {
    return await vestigasApi
      .put(ENDPOINT.PARSING_CASE.SAVE_NOTE(caseId), {
        json: { note },
        validate: { response: zodParsingCaseNoteResponseSchema },
      })
      .json<ParsingCaseNoteResponse>();
  } catch (error) {
    log.error({
      message: 'Error saving parsing case note',
      error,
    });

    const errorMessage = resolveMutationErrorMessage(
      error,
      ERROR_MESSAGE_BY_STATUS,
      () =>
        i18n.t(($) => $.saveParsingCaseNote.error.generic, {
          ns: 'data',
        }),
    );
    if (errorMessage) {
      ToastService.error(errorMessage);
    }

    throw error;
  }
};
